import { ClientOnly } from 'remix-utils/client-only'
import { Player } from './audio-player.client'

export function AudioPlayer() {
	return <ClientOnly>{() => <Player />}</ClientOnly>
}
